<template>
  <div class="app-container" >
    
  </div>
</template>

<script>

  export default {
    data() {
      return {
        desc: ''
      }
    },
    mounted() {
      history.pushState(null, null, document.URL);
      window.addEventListener("popstate", function () {
        history.pushState(null, null, document.URL);
      });
    }
  }
  
</script>
